import { useContext, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import PropTypes from "prop-types";
import PatientService from "../../services/PatientService";
import AuthContext from "../../context/authContext";
import UrlUtils from "../../utils/UrlUtils";

const useTokenAuth = (location) => {
  const { isAuthenticated, setCurrentToken, currentToken } = useContext(
    AuthContext
  );
  const { mode = null } = UrlUtils.getQueryParams(location.search);

  const [token, setToken] = useState(null);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [healthFacilityId, setHealthFacilityId] = useState(null);
  const [localIpp, setLocalIpp] = useState(null);
  const [globalIntentType, setGlobalIntentType] = useState(null);

  useEffect(() => {
    const extractAPIToken = (hash) => {
      const tokenWithoutHash = hash.substring(1).split("&")[0];
      return setToken(tokenWithoutHash);
    };

    return extractAPIToken(location.hash);
  }, [location]);

  const { isFetching } = useQuery({
    queryKey: ["patientByToken", token],
    retry: 0,
    queryFn: () =>
      PatientService.getPatientByToken(
        location.hash.substring(1).split("&")[0]
      ),
    onSettled: () => setToken(location.hash.substring(1).split("&")[0]),
    onSuccess: (res) => {
      setIsTokenValid(true);
      setGlobalIntentType(res.data.intentType);
      setCurrentToken(location.hash.substring(1).split("&")[0]);
      setHealthFacilityId(res.data.healthFacilityId);
      setLocalIpp(res.data.localIpp);
    },
    onError: () => setIsTokenValid(false),
    enabled:
      (currentToken !== token || (!isAuthenticated && !isTokenValid)) &&
      mode !== "MOBILE_ONLY"
  });

  return {
    isTokenValid,
    isFetching,
    healthFacilityId,
    localIpp,
    token,
    globalIntentType,
  };
};

useTokenAuth.propTypes = {
  location: {
    hash: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }
};
export default useTokenAuth;
